var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTemporaryCorporateMembership = function SvgTemporaryCorporateMembership(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 98.3 112.3",
    style: {
      enableBackground: "new 0 0 98.3 112.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.9,67.3c7.4,0,13.4-6,13.4-13.4s-6-13.4-13.4-13.4s-13.4,6-13.4,13.4l0,0C8.4,61.3,14.5,67.3,21.9,67.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89,44.2H41.4c-1.3,0-2.4,1.1-2.4,2.4c0,1.3,1.1,2.4,2.4,2.4H89c1.3,0,2.4-1.1,2.4-2.4 C91.4,45.2,90.3,44.2,89,44.2L89,44.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.4,63.7H67c1.3,0,2.4-1.1,2.4-2.4c0-1.3-1.1-2.4-2.4-2.4H41.4c-1.3,0-2.4,1.1-2.4,2.4 C39,62.6,40.1,63.7,41.4,63.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.9,30.7c7.4,0,13.4-6,13.4-13.4c0-7.4-6-13.4-13.4-13.4c-7.4,0-13.4,6-13.4,13.4c0,0,0,0,0,0 C8.4,24.7,14.4,30.7,21.9,30.7C21.9,30.7,21.9,30.7,21.9,30.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.4,12.4H89c1.4-0.1,2.4-1.3,2.3-2.6c-0.1-1.2-1.1-2.2-2.3-2.3H41.4c-1.4,0.1-2.4,1.3-2.3,2.6 C39.2,11.4,40.2,12.3,41.4,12.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.4,27H67c1.3,0,2.4-1.1,2.4-2.4c0-1.3-1.1-2.4-2.4-2.4H41.4c-1.3,0-2.4,1.1-2.4,2.4C39,26,40.1,27,41.4,27z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.3,49.2V23.6c-0.1-1.4-1.3-2.4-2.6-2.3c-1.2,0.1-2.2,1.1-2.3,2.3v25.6c0,1.3,1.1,2.4,2.4,2.4 S24.3,50.6,24.3,49.2C24.3,49.2,24.3,49.2,24.3,49.2L24.3,49.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.3,81.9V56.3C24.2,55,23,53.9,21.7,54c-1.2,0.1-2.2,1.1-2.3,2.3v25.6c0,1.3,1.1,2.4,2.4,2.4 C23.2,84.4,24.3,83.3,24.3,81.9C24.3,81.9,24.3,81.9,24.3,81.9L24.3,81.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.9,104c7.4,0,13.4-6,13.4-13.4c0-7.4-6-13.4-13.4-13.4s-13.4,6-13.4,13.4C8.4,98,14.5,104,21.9,104L21.9,104 z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89,80.8H41.4c-1.3,0-2.4,1.1-2.4,2.4s1.1,2.4,2.4,2.4H89c1.3,0,2.4-1.1,2.4-2.4S90.3,80.8,89,80.8L89,80.8 L89,80.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67,95.4H41.4c-1.3,0-2.4,1.1-2.4,2.4s1.1,2.4,2.4,2.4H67c1.3,0,2.4-1.1,2.4-2.4S68.4,95.4,67,95.4L67,95.4z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTemporaryCorporateMembership, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/TemporaryCorporateMembership.9783837b.svg";
export { ForwardRef as ReactComponent };